import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { UnregisterCallback } from 'history';
import { useHistory } from 'react-router';
import { history } from 'instantsearch.js/es/lib/routers';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchAllContent } from '../../components';

import './style.scss';

const Search = () => {
  const { t } = useTranslation();

  const routerHistory = useHistory();
  const removeHistoryListener = useRef<UnregisterCallback>();

  const routing = {
    router: history({
      start: (onUpdate) => {
        removeHistoryListener.current = routerHistory.listen(onUpdate);
      },
      dispose: () => removeHistoryListener.current,
    }),
  };

  return (
    <div className="Search">
      <Container>
        <SearchAllContent routing={routing}>
          <div className="row">
            <div className="col-12 col-lg-9">
              <h1 className="Search__title asH3">{t('pages.search.title')}</h1>

              <p className="Search__body body--large">
                {t('pages.search.body')}
              </p>
            </div>

            <div className="col-12">
              <SearchAllContent.SearchBar />
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-4">
              <SearchAllContent.Facets />
              {/* <SearchAllContent.ActiveFacets /> */}
            </div>

            <div className="col-12 col-lg-8">
              <div className="Search__stats">
                <SearchAllContent.Stats />
                <SearchAllContent.SortBy />
              </div>

              <SearchAllContent.Results />
              <SearchAllContent.Pagination />
            </div>
          </div>
        </SearchAllContent>
      </Container>
    </div>
  );
};

export default Search;
